import {combine, merge, sample} from 'effector';

import {RestError, showRestError} from 'core/errors';

import {
    organizationList$,
    fetchDataFx,
    Gate,
    pageNumber$,
    pageNumberChanged,
    pageSize$,
    pageSizeChanged,
    organizationBalanceChanged,
} from './index';

organizationList$
    .on(fetchDataFx.doneData, (_, data) => data)
    .on(organizationBalanceChanged, (state, {currentBalance, legalIdentityId}) => {
        if (!state) return state;
        return state.map((org) =>
            org.id === legalIdentityId ? {...org, balance: currentBalance} : org,
        );
    })
    .reset(Gate.close);
pageNumber$.reset(Gate.close);
pageSize$.reset(Gate.close);

sample({
    clock: merge([Gate.open, pageNumberChanged, pageSizeChanged]),
    source: combine({
        pageNumber: pageNumber$,
        pageSize: pageSize$,
    }),
    fn: ({pageNumber, pageSize}) => ({
        pageNumber,
        pageSize,
    }),
    target: fetchDataFx,
});

fetchDataFx.fail.watch(({error}) => showRestError(error as RestError));
